module.exports = __webpack_public_path__ + "static/media/pic1.b9f183e6.jpg";